import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IItemPropiedadAccion from './entidades/itemPropiedadAccion';

export default class ModeloItemPropiedad {
    public consultarItemsPropiedades(ItemId: number) {
        return manejadorRest<IRespuesta<IItemPropiedadAccion>>(
            () => negocio.post('ItemsPropiedades/ConsultarItemsPropiedadesCompuestaFiltro', { ItemId }),
            true
        );
    }
}
